<template>
  <div class="wrapper">
    <div class="header">
      <div class="container">
        <div class="home-header">
          <div style="color: #1c5c93;font-weight: 700;">
            <div style="display: flex;cursor: pointer">
              <div @click="() => {$router.push({path: '/'})}" class="main-font-all">
                <div class="main-font">51查U</div>
                <div class="main-url">51chau.com</div>
              </div>
              <div class="main-url-betch" @click="batchQuqery">
                批量查找地址余额
              </div>
            </div>
          </div>
          <div class="main-page-font" @click="() => {$router.push({path: '/'})}">
            首页
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 路由 -->
      <router-view/>
    </div>
    <!-- 底部-->
    <div class="footer">
      <a-popover position="right">
        <template #content>
          <div>{{ recipient }}</div>
        </template>
        <div class="footer-email" @click="openEmailClient">
          <icon-email/>
          官方邮箱
        </div>
      </a-popover>
<!--      <div class="footer-telegram" @click="linkCus">-->
<!--        <a-avatar :size="24">-->
<!--          <img alt="avatar" :src="require('@/assets/tel.png')"/>-->
<!--        </a-avatar>-->
<!--        官方客服-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import {Message} from '@arco-design/web-vue';

export default {
  name: 'HomeView',
  components: {},
  data() {
    return {
      recipient: '51danbao@gmail.com'
    }
  },
  methods: {
    linkCus() {
      window.open('https://t.me/dbw51', '_blank')
    },
    batchQuqery() {
      this.$router.push('/batchQuery')
    },
    openEmailClient() {
      this.$copyText(this.recipient).then(function (e) {
        Message.success('复制成功')
      }, function (e) {
        Message.error('复制失败')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cover {
  background-color: #FFFFFF;
  height: 313px;
  box-shadow: 0px 0px 9px #ddd;
  color: #1B5C93;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  .item-font-one {
    font-size: 17px;
    margin-top: 10px;
    font-weight: 800;
  }

  .item-font-two {
    font-size: 21px;
    margin-top: 10px;
    font-weight: 800;
  }

  .item-font-three {
    font-size: 17px;
    margin-top: 10px;
    font-weight: 500;
  }
}

.cover:hover {
  color: #CCDAE7 !important;
}

.cover:hover:after {
  color: #FFFFFF !important;
}

.container {
  max-width: 1520px;
  min-width: 320px !important;

  padding-right: var(--bs-gutter-x, .75rem);
  padding-left: var(--bs-gutter-x, .75rem);
  margin-right: auto;
  margin-left: auto;

  .nav-item {
    margin-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #f5f9fc !important;

    .row {
      display: flex;
      justify-content: center;
      align-items: center;

      flex-wrap: wrap;
      margin-top: 52px;
      margin-bottom: 60px;
    }

    .col-md-3 {
      width: 360px;
      padding-right: 10px;
      margin-bottom: 90px;
    }

    .nav-item-cus {
      margin-top: 50px;
      margin-bottom: 40px;

      .grid-demo .arco-col {
        display: flex;
        justify-content: center;
        align-items: center;

        height: 98px;
        line-height: 48px;
        text-align: center;
        background-color: #FFFFFF !important;
      }
    }

    .nav-font-price {
      margin-top: 52px;
      font-size: 20px;
      padding-top: 40px;
      font-weight: 600;
      color: #5c768d !important
    }

    .nav-font-info {
      margin-top: 12px;
      font-size: 16px;
      font-weight: 600;
      color: #9e9e9e !important
    }
  }

  .search {
    min-width: 320px !important;
    width: 70% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    padding-top: 20px;

    .input-search {
      width: 100%;
      height: 54px !important;

      .arco-btn {
        height: 52px !important;
        width: 106px !important;
      }
    }
  }


  .search-font {
    min-width: 320px !important;
    color: #5c768d !important;
    margin-top: 150px;
    font-size: 24px;
  }

  .home-header {
    margin-top: 30px;
    height: 65px;

    display: flex;
    justify-content: space-between;

    .main-font-all:hover {
      color: #CCDAE7 !important;
    }

    .main-font-all:hover:after {
      color: inherit !important;
    }

    .main-font {
      font-size: 32px;
    }

    .main-font:hover {
      color: #CCDAE7 !important;
    }

    .main-font:hover:after {
      color: inherit !important;
    }


    .main-url {
      font-size: 22px;
      cursor: pointer;
    }

    .main-url:hover {
      color: #CCDAE7 !important;
    }

    .main-url:hover {
      color: inherit !important;
    }

    .main-url-betch {
      font-size: 15px !important;
      margin-left: 20px !important;

      display: flex;
      justify-content: flex-end;
      align-items: flex-end;

      padding-bottom: 10px;
      cursor: pointer;
    }

    .main-url-betch:hover {
      color: #CCDAE7 !important;
    }

    .main-url-betch:hover:after {
      color: inherit !important;
    }

    .main-page-font {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      cursor: pointer;

      color: #1c5c93;
      font-weight: 700;
    }

    .main-page-font:hover {
      color: #CCDAE7 !important;
    }

    .main-page-font:hover:after {
      color: #1c5c93 !important;
    }

  }
}

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.header {
  flex: 0;
}

.content {
  flex: 1;
}

.footer {
  flex: 1;
  min-height: 212px;
  background-color: #587187;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  padding-left: 60px;

  .footer-email {
    margin-top: 80px;
    font-size: 24px !important;
    color: #FFFFFF;
    cursor: pointer;
  }

  .footer-email:hover {
    color: #CCDAE7 !important;
  }

  .footer-email:hover:after {
    color: #FFFFFF !important;
  }

  .footer-telegram {
    margin-top: 10px;
    font-size: 21px !important;
    color: #FFFFFF;
    cursor: pointer;
  }

  .footer-telegram:hover {
    color: #CCDAE7 !important;
  }

  .footer-telegram:hover:after {
    color: #FFFFFF !important;
  }
}
</style>
